import { useMutation, useQuery } from '@tanstack/react-query'
import { AXIOS_INSTANCE } from '../api'
import { queryClient } from '../store/provider/TanStackProvider'
import { CodeResMock } from '../types/code.type'
import { GeneralResMock } from '../types/general.type'

export const useCode = (arg?: { patient_id: string }) => {
  const patient_id = arg?.patient_id
  const { data, isLoading } = useQuery({
    queryFn: async () => {
      const { data } = await AXIOS_INSTANCE.get<GeneralResMock<CodeResMock[]>>('codes', {
        params: { ...(patient_id && { patient_id }) }
      })
      return data
    },
    queryKey: ['codes', { patient_id }]
  })

  const { mutateAsync: addCode } = useMutation({
    mutationFn: async (payload: any) => {
      const { data } = await AXIOS_INSTANCE.post<GeneralResMock<CodeResMock>>('codes', payload, {
        headers: { 'Content-Type': 'application/vnd.api+json' }
      })
      return data.data
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['codes'] })
  })

  return {
    addCode,
    codes: data?.data,
    isLoading
  }
}
